import React, { useState, useEffect, useRef } from 'react';

// Shown before payment when the cart contains any cafe item. Cafe prep
// needs a pickup name on the slip/sticker so the purchaser can be called
// when their order is ready. Kitchen-only carts skip this modal.
export default function PosPickupNameModal({
  initialName = '',
  purpose = 'payment',
  onConfirm,
  onCancel,
}) {
  const [name, setName] = useState(initialName || '');
  const inputRef = useRef(null);
  const isEdit = purpose === 'edit';

  useEffect(() => {
    // Autofocus so staff can type immediately on an external keyboard
    // or bring up the iPad soft keyboard without an extra tap.
    const t = window.setTimeout(() => inputRef.current?.focus?.(), 50);
    return () => window.clearTimeout(t);
  }, []);

  const trimmed = name.trim();
  const canConfirm = trimmed.length >= 1;

  const submit = (e) => {
    e?.preventDefault?.();
    if (!canConfirm) return;
    onConfirm(trimmed.slice(0, 60));
  };

  return (
    <div className="pos-modal-backdrop" onClick={onCancel} role="presentation">
      <form
        className="pos-modal pos-pickup-name-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={submit}
      >
        <h2 className="pos-modal-title">Pickup name</h2>
        <p className="pos-modal-subtitle">
          {isEdit
            ? 'Change the name that prints on the cafe sticker — add a last name if there are two people with the same first name.'
            : 'This order has cafe items. Enter the customer\'s name — it prints on the cafe sticker so staff can call it out when ready.'}
        </p>
        <label className="pos-pickup-name-label" htmlFor="pos-pickup-name">
          Name for pickup
        </label>
        <input
          id="pos-pickup-name"
          ref={inputRef}
          className="pos-pickup-name-input"
          type="text"
          autoComplete="name"
          autoCapitalize="words"
          enterKeyHint="done"
          maxLength={60}
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Mary"
        />
        <div className="pos-modal-actions">
          <button type="button" className="pos-modal-btn pos-modal-btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button
            type="submit"
            className="pos-modal-btn pos-modal-btn-primary"
            disabled={!canConfirm}
          >
            {isEdit ? 'Save name' : 'Continue to payment'}
          </button>
        </div>
      </form>
    </div>
  );
}
